import React, { Component } from 'react';
import ReactTable from 'react-table-6';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class CustomEntityType extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({
        hideDialog: false,
        hideAddDialog: false,
        hideDeletePopup: false,

        disabled: false
      });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchCustomEntityTypeApi()
        this.dialogClose();
      }
    }];
    //for add dialog component ok click
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchCustomEntityTypeApi()
        this.dialogClose();
        this.setState({
          disabled: false
        })

      }
    }];
    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': (props) => {
        this.deleteCustomEnityTypeApi(this.state.propsId)
      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ hideDeletePopup: false });
      }
    }];
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.dialogInstance.hide();
        this.fetchCustomEntityTypeApi();

      }
    }];
    this.state = {
      data: [{
        id: '',
        typeName: '',
        description: '',
        deleteRow: false,
        contentEditiable: "false"
      }],
      pageNum: null,
      disabled: false,
      fields: '',
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      hideDialog: false,
      hideAddDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      makeEditButtonAfterRefresh: '-1',
      successResp: false
    };
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.currentSrc = "";
    this.newRowId = "0";
  }
  componentDidMount = () => {
    setTimeout(() => {
      this.fetchCustomEntityTypeApi();
    }, 300);
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchCustomEntityTypeApi(event.projectId);
    });
  }
  markAsBeingEdited = (id) => {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);

  }

  saveCustomEntityTypeApi(props, e) {

    this.state.editedId = "-1";
    props.original.typeName = document.getElementById("name" + props.index).innerText.trim();
    props.original.description = document.getElementById("description" + props.index).innerText.trim();
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.typeName, props.original.description);
    if ((validateResult) == true) {
      var updatedData = {
        typeName: props.original.typeName,
        description: props.original.description,
        projectId: localStorage.getItem('currentProjectId')
      };
      var customEntityTypeController = this;
      $.ajax({
        url: "/api/custom-entity-type",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            customEntityTypeController.notifyAdded();
            customEntityTypeController.fetchCustomEntityTypeApi();
            customEntityTypeController.setState({
              disabled: false
            })
          } else {
            customEntityTypeController.notifyError(res.result);
          }
        },

        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
  }
  notifyAdded() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Custom Entity Type Added Successfully</b>, {
      position: "top-center",

    });
  }


  notifyError(response) {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/warn.svg" style={{
        paddingRight: '0px',
        height: '20px', width: '20px'
      }} content="" />{response}</b>, {
      position: "top-center"
    });
  }


  updateCustomEntityTypeApi(props, e) {
    this.state.editedId = "-1";
    props.original.typeName = document.getElementById("name" + props.index).innerText.trim();
    props.original.description = document.getElementById("description" + props.index).innerText.trim();

    this.setState(this.state);
    var validateResult = this.validateCells(props.original.typeName, props.original.description);
    if ((validateResult) == true) {
      var updatedData = {
        typeName: props.original.typeName,
        description: props.original.description,
        id: props.original.id,
        projectId: localStorage.getItem("currentProjectId")
      };
      var customEntityTypeController = this
      $.ajax({
        url: "/api/custom-entity-type",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {

            customEntityTypeController.notifyUpdate();
            customEntityTypeController.fetchCustomEntityTypeApi();
          } else {

            customEntityTypeController.notifyError(res.result);
          }
        },

        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
  }

  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Custom Entity Type Updated Successfully</b>, {
      position: "top-center",

    });
  }

  deleteCustomEnityTypeApi = (id) => {
    var customEntityTypeController = this;

    $.ajax({
      url: "/api/custom-entity-type/" + id,
      async: false,
      method: 'DELETE',
      headers: {
        "Authorization": "Bearer " +
          localStorage.getItem("access_token")
      },

      success: function (res) {
        if (res.success === true) {
          customEntityTypeController.setState({ deleteRow: true });
          customEntityTypeController.setState({ hideDeletePopup: false });
          customEntityTypeController.notifyDelete();
        } else {
          customEntityTypeController.notifyError(res.result);
        }
      },

      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    customEntityTypeController.fetchCustomEntityTypeApi();
  }


  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Custom Entity Type Deleted Successfully</b>, {
      position: "top-center",

    });

  }

  editCell(props, e) {
    this.markAsBeingEdited(props.original.id);
  }

  fetchCustomEntityTypeApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    let customEntityTypeController = this;
    $.ajax({
      url: "/api/custom-entity-type",
      async: false,
      method: 'GET',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      data: { projectId: projectId },
      success: function (res) {
        if (res.success === true) {
          customEntityTypeController.setState({
            data: res.result,
            successResp: true,
            disabled: false
          });
        } else {
          customEntityTypeController.notifyError(res.result);
        }
      },

      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }

  notifyFailedLoad() {
    toast(<b style={{ color: "#007aff" }}>Failed to Load</b>, {

      position: "bottom-center",
      color: "#007aff"
    });
  }
  addRow = (data) => {
    var rowController = this;
    if (rowController.state.pageNum != 0) {
      rowController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      typeName: '',
      description: ''
    });
    this.setState({
      data: this.state.data,
      disabled: true
    })
  }
  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  validateCells(name, description) {
    if ((name == "" || description == "")) {
      this.NotifyEmptyFields();
      return false;
    } else {
      return true;
    }
  }
  validateUrlCell(url) {
    var pattern = new RegExp(/^((https):\/\/)/);
    if (!pattern.test(url)) {
      this.NotifyInvalidUrlFiled();
      return false;
    }
    else {
      return true;
    }
  }
  NotifyEmptyFields() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all fields</b>, {
      position: "top-center"
    });
  }
  NotifyInvalidUrlFiled() {
    toast(<b style={{ color: "#007aff" }}>
      <img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;A secured URL(Eg:https://dhee.ai) is needed</b>, {
      position: "bottom-center",
      color: "#007aff"

    });
  }

  viewClickedCell(props, e) {
    if (this.state.viewedId == props.original.id) {
      this.closeClickedCell(props, e)
      return
    }
    this.state.viewedId = props.original.id;
    props.original.name = document.getElementById("name" + props.index).innerText;
    props.original.url = document.getElementById("url" + props.index).innerText;
    props.original.userName = document.getElementById("userName" + props.index).innerText;
    props.original.password = document.getElementById("password" + props.index).value;
    this.setState(this.state);
  }
  closeClickedCell(props, e) {
    this.state.viewedId = '--1';
    this.setState(this.state);
  }
  onPasswordhandleChange(event, props) {

    props.original.password = event.target.value;
    this.setState(
      this.state);

  }
  onNamehandleChange(event, props) {

    props.original.name = document.getElementById("name" + props.index).innerText;
    this.setState(
      this.state);

  }
  onUrlhandleChange(event, props) {

    props.original.url = document.getElementById("url" + props.index).innerText;
    this.setState(
      this.state);

  }
  onUserNameHandleChange(event, props) {

    props.original.userName = document.getElementById("userName" + props.index).innerText;
    this.setState(
      this.state);

  }
  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.setState({ disabled: false })
    this.fetchCustomEntityTypeApi();
  }
  render() {
    const { data } = this.state;

    const columns = [
      {
        Header: <b>Type Name</b>,
        accessor: 'name',
        Cell: props => (<div
          Align="left" className="input"
          style={{
            padding: '8px', width: '98%', borderBottom: 'none',
            border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
              '1px solid #D2D4DC' : 'none', borderRadius:
              (props.original.id == undefined || props.original.id == this.state.editedId) ? '2px' : 'none', paddingLeft: '2px'
          }}
          suppressContentEditableWarning
          contentEditable={!((props.original.id == undefined) ? false :
            props.original.id != this.state.editedId) ? "plaintext-only" : false}
          type="text" id={"name" + props.index} value={props.original.id == undefined ? "" :
            props.original.typeName}
        >{props.original.typeName}</div>)
      },
      {
        Header: () => <b>Description</b>,
        accessor: 'text',
        Cell: props => (
          <div name="text">
            <div className="textarea"
              style={{
                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                width: '98%',
                border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
                  '1px solid #D2D4DC' : 'none',
                borderRadius: (props.original.id == undefined || props.original.id == this.state.editedId) ? '2px' : 'none'
              }}
              id={"description" + props.index}
              contentEditable={!((props.original.id == undefined) ? false :
                props.original.id != this.state.editedId) ? "plaintext-only" : false}
            >{props.original.description}
            </div>
          </div>)
      },
      {
        Header: <b>Action</b>,
        width: 100,
        Cell: props => {

          return (
            <div id="action">
              <div style={{ marginTop: '-9px' }}>
                <p>
                  <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                    <img className="img-responsive"
                      style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                      title={(props.original.id == undefined) ||
                        (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                      src={(props.original.id == null) ?
                        this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                          this.editImageSrc : this.saveImageSrc)}
                      onClick={(e) => {
                        (props.original.id == null) ?
                          this.saveCustomEntityTypeApi(props, e) :
                          (props.original.id == this.state.editedId) ?
                            this.updateCustomEntityTypeApi(props, e) :
                            this.editCell(props, e);
                      }}
                    /></button>
                  <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                    <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                      style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                      title="Delete"
                      onClick={() => {
                        (props.original.id) === undefined ?
                          this.fetchCustomEntityTypeApi() :
                          this.setState({
                            hideDeletePopup: true, deletePropIndex: props.index,
                            propsId: props.original.id
                          })
                      }}
                    /></button>
                </p>
              </div>
            </div>
          )
        },
        width: 100
      }
    ]

    return (
      <div style={{ backgroundColor: '#F9F9FB' }}>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: 'center' }}
        />
        <div style={{ display: this.state.successResp ? 'block' : 'none', backgroundColor: '#F9F9FB' }}>
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

          {/* for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />

          <div >
            <div className="row" style={{ marginBottom: '-22px' }}>
              <div className="col-sm-6">

                <h6 className="nav-item" style={{ color: '#282a65', marginLeft: '15px', marginTop: '24px' }}>
                  Define Custom Entity Types</h6>

              </div>
              <div className="col-sm-6" Align='right'>

                <button className="btn action-button "
                  id="addMsg"
                  onClick={this.state.disabled ? this.NotifyEmptyFields : this.addRow}
                  title="Add" style={{ marginLeft: '35px' }}>
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button onClick={this.refreshData} className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png" title="Refresh"></img>
                </button>
              </div>
            </div>

          </div>
          <div style={{ marginTop: "21px", backgroundColor: '#F9F9FB' }}>
            <ReactTable
              data={data}
              columns={columns}
              defaultPageSize={10}
              onPageChange={this.onPageChange}
              page={this.state.pageNum}
              pageSizeOptions={[5, 10, 15]}
              style={{
                backgroundColor: 'white',
                marginRight: '12px', marginLeft: '12px'
              }}
            /></div>
          <br />


          <ToastContainer className="Toast-at-center" />



          {/*Dialog Component For Deletion Confirmation*/}
          <DialogComponent width='400px' animationSettings={this.settings}
            header='Backend API' showCloseIcon={true} buttons={this.buttons}
            ref={dialog => this.dialogInstance = dialog}
            visible={this.state.hideDeletePopup}
            close={this.dialogClose}>
            <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
              content="" />&nbsp;Do you want to delete the custom entity type?<br />Note: Press 'Yes' to delete or press 'No' to decline.
          </DialogComponent>


        </div>
      </div>
    );
  }
}
export default CustomEntityType;



// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/CustomEntityType.js